
export default function QualityAndValue() {
  const features = [
    {
      icon: 'ri-award-line',
      title: 'Tecnologia de Ponta',
      description: 'Equipamentos de última geração com GPS de alta precisão e conectividade 4G para rastreamento em tempo real sem falhas.'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Certificação Nacional',
      description: 'Empresa certificada e homologada pela Anatel, garantindo qualidade e conformidade com todas as normas brasileiras.'
    },
    {
      icon: 'ri-team-line',
      title: 'Equipe Especializada',
      description: 'Profissionais treinados e experientes em instalação e monitoramento, prontos para atender suas necessidades.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Melhor Custo-Benefício',
      description: 'Planos acessíveis com mensalidades que cabem no seu bolso, sem comprometer a qualidade do serviço.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Instalação Profissional',
      description: 'Instalação realizada por técnicos certificados, sem danificar o veículo e com garantia de funcionamento.'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Suporte Premium',
      description: 'Atendimento ágil e eficiente via WhatsApp, telefone ou app, sempre que você precisar de ajuda.'
    }
  ];

  return (
    <section id="qualidades" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Qualidade e Custo-Benefício
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            O melhor rastreamento do mercado com preço justo e tecnologia superior
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 group cursor-pointer"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-black to-gray-800 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-3xl text-yellow-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-black rounded-2xl p-10 md:p-16 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-500/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-yellow-500/10 rounded-full blur-3xl"></div>
          
          <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Planos a Partir de
              </h3>
              <div className="flex items-baseline gap-2 mb-6">
                <span className="text-6xl md:text-7xl font-bold text-yellow-500">R$ 59,90</span>
                <span className="text-2xl text-white/80">/mês</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center gap-3 text-white">
                  <i className="ri-check-line text-2xl text-yellow-500"></i>
                  <span className="text-base">Sem taxa de adesão</span>
                </li>
                <li className="flex items-center gap-3 text-white">
                  <i className="ri-check-line text-2xl text-yellow-500"></i>
                  <span className="text-base">Instalação inclusa</span>
                </li>
                <li className="flex items-center gap-3 text-white">
                  <i className="ri-check-line text-2xl text-yellow-500"></i>
                  <span className="text-base">App ilimitado</span>
                </li>
                <li className="flex items-center gap-3 text-white">
                  <i className="ri-check-line text-2xl text-yellow-500"></i>
                  <span className="text-base">Suporte 24/7</span>
                </li>
              </ul>
              <a
                href="https://wa.me/5511954662476"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-yellow-500 text-black px-8 py-4 rounded-lg text-lg font-bold hover:bg-yellow-400 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                Solicitar Orçamento
              </a>
            </div>
            
            <div className="hidden md:block">
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10">
                <h4 className="text-xl font-bold text-white mb-6">Por que somos mais baratos?</h4>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3 text-white/90">
                    <i className="ri-checkbox-circle-fill text-xl text-yellow-500 mt-1"></i>
                    <span className="text-sm">Operação otimizada e eficiente</span>
                  </li>
                  <li className="flex items-start gap-3 text-white/90">
                    <i className="ri-checkbox-circle-fill text-xl text-yellow-500 mt-1"></i>
                    <span className="text-sm">Sem intermediários, direto da franquia</span>
                  </li>
                  <li className="flex items-start gap-3 text-white/90">
                    <i className="ri-checkbox-circle-fill text-xl text-yellow-500 mt-1"></i>
                    <span className="text-sm">Tecnologia própria reduz custos</span>
                  </li>
                  <li className="flex items-start gap-3 text-white/90">
                    <i className="ri-checkbox-circle-fill text-xl text-yellow-500 mt-1"></i>
                    <span className="text-sm">Foco em volume e satisfação do cliente</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
